import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

// Container and animation variants
const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const productVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Product = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const productTitle = title.split(" ").join("-").toLowerCase();

  return (
    <motion.div variants={productVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair font-semibold">{title}</p>
        <p className="mt-5 text-sm">
          High-quality and customizable templates designed to streamline your business processes and enhance your online presence.
        </p>
      </div>
      <img
        src={`../assets/${productTitle}.jpeg`}
        alt={productTitle}
        className="w-full h-full object-cover"
      />
    </motion.div>
  );
};

const Products = () => {
  return (
    <section id="products" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-red">OUR</span> PRODUCTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <motion.p
          className="mt-10 mb-10 text-sm"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          Explore our range of professionally designed templates and solutions,
          each tailored to provide an intuitive and elegant user experience.
        </motion.p>
      </motion.div>

      {/* PRODUCTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3 gap-8"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-red
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold text-white"
          >
            BEAUTIFUL USER INTERFACES
          </div>
          <Product title="E-commerce Template" />
          <Product title="AI Dashboard" />

          {/* ROW 2 */}
          <Product title="Portfolio Template" />
          <Product title="Project Management App" />
          <Product title="Fitness App" />

          {/* ROW 3 */}
          <Product title="Admin Dashboard" />
          <Product title="Social Media App" />
          <div
            className="flex justify-center text-center items-center p-10 bg-blue
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold text-white"
          >
            SMOOTH USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Products;
